module.exports = __webpack_public_path__ + "static/media/LicenseLanaHill_5x7.75fd69db.png";